import { ReactComponent as IconColors } from 'core/assets/images/colors.svg'
import { ReactComponent as IconFlavor } from 'core/assets/images/flavor.svg'
import { ReactComponent as IconMaterial } from 'core/assets/images/material.svg'
import { ReactComponent as IconSize } from 'core/assets/images/size.svg'
import { ReactComponent as IconVoltage } from 'core/assets/images/voltage.svg'
import { IOptionProps } from 'core/components/VariationsAutocompleteField/types'
import i18n from '../i18n'

export enum EVariationTypes {
  COLOR = 'color',
  SIZE = 'size',
  MATERIAL = 'material',
  VOLTAGE = 'voltage',
  ADDITIONAL = 'additional',
  CAPACITY = 'capacity',
  CAPSULE = 'capsule',
  CONSOLE = 'console',
  SIDE = 'side',
  OPERATOR = 'operator',
  PIECE = 'piece',
  INCH = 'inch',
  QUANTITY = 'quantity',
  FLAVOR = 'flavor',
  VOLUME = 'volume',
}

export const MAIN_VARIATION_TYPES_LIST = [
  { label: i18n.t('multivariation.types.color'), value: EVariationTypes.COLOR, Icon: IconColors },
  { label: i18n.t('multivariation.types.size'), value: EVariationTypes.SIZE, Icon: IconSize },
  {
    label: i18n.t('multivariation.types.material'),
    value: EVariationTypes.MATERIAL,
    Icon: IconMaterial,
  },
  {
    label: i18n.t('multivariation.types.voltage'),
    value: EVariationTypes.VOLTAGE,
    Icon: IconVoltage,
  },
]

export const MAIN_VARIATION_NETS_TYPES_LIST = [
  { label: i18n.t('multivariation.types.color'), value: EVariationTypes.COLOR, Icon: IconColors },
  { label: i18n.t('multivariation.types.size'), value: EVariationTypes.SIZE, Icon: IconSize },
  {
    label: i18n.t('multivariation.types.voltage'),
    value: EVariationTypes.VOLTAGE,
    Icon: IconVoltage,
  },
  {
    label: i18n.t('multivariation.types.flavor'),
    value: EVariationTypes.FLAVOR,
    Icon: IconFlavor,
  },
]

export const OTHER_VARIATION_TYPES_LIST = [
  {
    label: i18n.t('multivariation.types.additional'),
    value: EVariationTypes.ADDITIONAL,
    helperText: '',
  },
  {
    label: i18n.t('multivariation.types.capacity'),
    value: EVariationTypes.CAPACITY,
    helperText: '',
  },
  { label: i18n.t('multivariation.types.capsule'), value: EVariationTypes.CAPSULE, helperText: '' },
  { label: i18n.t('multivariation.types.console'), value: EVariationTypes.CONSOLE, helperText: '' },
  { label: i18n.t('multivariation.types.side'), value: EVariationTypes.SIDE, helperText: '' },
  {
    label: i18n.t('multivariation.types.operator'),
    value: EVariationTypes.OPERATOR,
    helperText: '',
  },
  { label: i18n.t('multivariation.types.piece'), value: EVariationTypes.PIECE, helperText: '' },
  { label: i18n.t('multivariation.types.inch'), value: EVariationTypes.INCH, helperText: '' },
  {
    label: i18n.t('multivariation.types.quantity'),
    value: EVariationTypes.QUANTITY,
    helperText: '',
  },
  {
    label: i18n.t('multivariation.types.flavor'),
    value: EVariationTypes.FLAVOR,
    helperText: i18n.t('multivariation.helperText.flavor'),
  },
  {
    label: i18n.t('multivariation.types.volume'),
    value: EVariationTypes.VOLUME,
    helperText: i18n.t('multivariation.helperText.volume'),
  },
]

export const DEFAULT_VARIATION_OPTIONS_BY_TYPE: Record<EVariationTypes, IOptionProps[]> = {
  [EVariationTypes.COLOR]: [
    { color: '#FFFF00', title: 'Amarelo' },
    { color: '#0000FF', title: 'Azul' },
    { color: '#FFFFFF', title: 'Branco' },
    { color: '#808080', title: 'Cinza' },
    { color: '#FFA500', title: 'Laranja' },
    { color: '#8B4513', title: 'Marrom' },
    { color: '#000000', title: 'Preto' },
    { color: '#FF69B4', title: 'Rosa' },
    { color: '#663399', title: 'Roxo' },
    { color: '#00FF00', title: 'Verde' },
    { color: '#FF0000', title: 'Vermelho' },
  ],
  [EVariationTypes.SIZE]: [
    { title: 'PP' },
    { title: 'P' },
    { title: 'M' },
    { title: 'G' },
    { title: 'GG' },
    { title: '30' },
    { title: '31' },
    { title: '32' },
    { title: '33' },
    { title: '34' },
    { title: '35' },
    { title: '36' },
    { title: '37' },
    { title: '38' },
    { title: '39' },
    { title: '40' },
    { title: '41' },
    { title: '42' },
    { title: '43' },
    { title: '44' },
    { title: '45' },
  ],
  [EVariationTypes.MATERIAL]: [],
  [EVariationTypes.VOLTAGE]: [{ title: '127V' }, { title: '220V' }, { title: 'Bivolt' }],
  [EVariationTypes.ADDITIONAL]: [],
  [EVariationTypes.CAPACITY]: [],
  [EVariationTypes.CAPSULE]: [],
  [EVariationTypes.CONSOLE]: [],
  [EVariationTypes.SIDE]: [],
  [EVariationTypes.OPERATOR]: [],
  [EVariationTypes.PIECE]: [],
  [EVariationTypes.INCH]: [],
  [EVariationTypes.QUANTITY]: [],
  [EVariationTypes.FLAVOR]: [
    { title: 'Abacate' },
    { title: 'Abacaxi' },
    { title: 'Amendoim' },
    { title: 'Baunilha' },
    { title: 'Chocolate' },
    { title: 'Coco' },
    { title: 'Flocos' },
    { title: 'Goiaba' },
    { title: 'Kiwi' },
    { title: 'Limão' },
    { title: 'Manga' },
    { title: 'Maracujá' },
    { title: 'Morango' },
    { title: 'Uva' },
  ],
  [EVariationTypes.VOLUME]: [
    { title: '50ml' },
    { title: '75ml' },
    { title: '100ml' },
    { title: '125ml' },
    { title: '150ml' },
    { title: '175ml' },
    { title: '200ml' },
    { title: '250ml' },
    { title: '300ml' },
    { title: '350ml' },
    { title: '400ml' },
    { title: '450ml' },
    { title: '500ml' },
    { title: '550ml' },
    { title: '600ml' },
    { title: '750ml' },
    { title: '800ml' },
    { title: '850ml' },
    { title: '900ml' },
    { title: '950ml' },
    { title: '1L' },
    { title: '2L' },
  ],
}
